import { Component, Input, ViewContainerRef, ViewChild, HostListener, ComponentFactoryResolver, ChangeDetectorRef } from '@angular/core';
import { NavController, NavParams, Events, ModalController, AlertController, ToastController } from 'ionic-angular';
import { ContextMenuComponent } from 'ngx-contextmenu';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { StoreWrapProvider } from '../../providers/store-wrap/store-wrap';
// import { componentHolderService } from '../../providers/component-holder.service/component-holder.service';
import { RuleEngineSetupComponent } from '../../components/rule-engine-setup/rule-engine-setup';
import { TemplateListsPage } from '../template-lists/template-lists';
import { DriveSharePage } from '../drive-share/drive-share';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { PrivateShareComponent } from '../../components/private-share/private-share'
import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';
import { FixedSizeVirtualScrollStrategy } from '@angular/cdk/scrolling';

const shareScreen = 98;
const fullScreen = 100;
@Component({
  selector: 'page-share',
  templateUrl: 'share.html',
})
export class SharePage {
  head_width: boolean = false;
  @ViewChild(ContextMenuComponent, { static: true }) public basicMenu: ContextMenuComponent;
  @ViewChild('container', { read: ViewContainerRef, static: false }) viewContainerRef: ViewContainerRef;
  @ViewChild('privateShareContainer', { read: ViewContainerRef, static: false }) privateviewContainerRef: ViewContainerRef
  @ViewChild('otherMenu', { static: true }) public otherMenu: ContextMenuComponent;
  @Input() sharedData: any;
  selectedFolder: any;
  showListView: boolean = false;
  objCurrentParentFolder: any;
  templateProperty: any;
  templateID: any;
  objFilterParams: any;
  objCurrentFolder: any;
  showPaste: any = false;
  showTempList: any = false;
  SearchText: any;
  showTemplateStatus = false;
  showProgressStatus = false;
  // showListView: any = false;
  // objFilterParams: any = [];
  showClickedFiles: any;
  showMainContainer = true;
  showComponentHolder = false;
  showSplitContainer: any = false;
  templateSelection: string;
  showMultitemp: any;
  objCurrentFolderProperties: any;
  componentRef: any;
  folderStatusMove: boolean;
  showFolderMenu: boolean;
  oldFolderName: any;
  screenWidth: number;
  objCurrentFolders: any = [];
  broadcastSubs: any;
  shareWidth: any = shareScreen;
  @Input() set fileshared(v: any) {
    if (v) {
      this.showComponentHolder = v;
    }
  }
  constructor(public communicationServ: CommunicationServiceProvider, private modal: ModalController, private cdr: ChangeDetectorRef, public configureService: ConfigureServiceProvider, public toastController: ToastController, private alertCtrl: AlertController, public configApiService: ConfigApiServiceProvider, public navCtrl: NavController, public navParams: NavParams, public events: Events, private storeWrap: StoreWrapProvider, public driveService: DriveServiceProvider, private resolver: ComponentFactoryResolver) {
  }
  ngAfterViewChecked() {
    //your code to update the model
    this.cdr.detectChanges();
  }
  ngOnInit() {
    if (this.sharedData.sharedInfo.accessType != "public" && this.sharedData.ShareType != "File" && this.sharedData.sharedInfo['IsReadOnlyShare'] == undefined) {
      this.showPopup();
    }
    this.events.subscribe("fileParams", (filterParams) => {
      this.objFilterParams = filterParams;
    });

    this.driveService.broadcastInfo({ src: 'share', event: 'selectPageActive', page: 'Drive', status: true });


    this.screenWidth = window.innerWidth;
    if (window.innerWidth > 700) {
      this.head_width = false;
    } else {
      this.head_width = true;
    }
    if (this.sharedData && this.sharedData.sharedInfo.accessType == "public" && this.sharedData.sharedInfo.ShareType == "Folder") {
      this.head_width = true;
    }
  }


  ngAfterViewInit() {
    this.get_Width();
    this.initDriveEvents(this.events);
    if (this.sharedData.sharedInfo['mailSendType'] != undefined) {
      this.screenWidth = fullScreen;
      this.templateID = this.sharedData.sharedInfo['sharedFolder'].template[0].id;
      this.templateProperty = this.sharedData.sharedInfo['sharedFolder'].template[0];
      this.driveService.CurrentFilesData = this.sharedData.sharedInfo.rowData;
      this.loadGridData();
    } else {
      this.driveService.getShareRootFolders({}, (rootfolder) => {
        this.driveService.objRootFolder = rootfolder;
        this.driveService.gotoFolder(null); this.storeWrap.storeTemplates
        if (this.sharedData && this.sharedData.ShareType != "Folder") {
          this.showComponentHolder = true;
          if (this.driveService.objCurrentFolder.folders.findIndex(folder => folder.name == 'FileShared') == -1) {
            let folder = this.driveService.createFolderStructure('FileShared', this.storeWrap.storeTemplates.Share);
            folder.template.push(this.storeWrap.storeTemplates.Share);
            this.driveService.shareFolder(folder, rootfolder, false, ((data) => {
            }))
          }
          const componentFactory = this.resolver.resolveComponentFactory(PrivateShareComponent);
          this.componentRef = this.privateviewContainerRef.createComponent(componentFactory);
          this.componentRef.instance.sharedData = this.sharedData;
          this.showMainContainer = false;
        } else if (this.sharedData && this.sharedData.ShareType == "Folder") {
          if (this.sharedData.sharedInfo.accessType == "public") {
            this.driveService.objRootFolder.folder_id = 0;
            this.driveService.objCurrentFolder.folders.push(this.sharedData.sharedInfo.sharedFolder);
            this.driveService.objCurrentFolder.folders.path = [0];
            this.driveService.objCurrentFolder.folders.parent_folder_id = 0;
            this.driveService.objRootFolder = this.driveService.objCurrentFolder;
          } else {
            this.driveService.objRootFolder.folder_id = 0;
            this.sharedData.sharedInfo.sharedFolder.path = [0];
            this.sharedData.sharedInfo.sharedFolder.parent_folder_id = 0;
            if (!this.sharedData.sharedInfo.sharedFolder.hasOwnProperty('folders')) {
              this.sharedData.sharedInfo.sharedFolder = Object.assign({}, this.sharedData.sharedInfo.sharedFolder, { 'folders': [] });
            }
            this.driveService.objRootFolder.folders.push(this.sharedData.sharedInfo.sharedFolder);
          }
          let folderIndex = this.driveService.objRootFolder.folders.findIndex(folder => folder.folder_id == this.sharedData.sharedInfo.sharedFolder.folder_id)
          if (folderIndex != -1) {
            this.showFolderContent(this.driveService.objRootFolder.folders[folderIndex], folderIndex);
          }
        }
      });
    }



    this.objCurrentFolder = this.driveService.getFolderStructure()
    this.get_Width();
  }

  showPopup() {
    let alert = this.alertCtrl.create({
      title: "Do you want to save the folder to your Drive",
      buttons: [
        {
          text: 'NO',
          role: 'NO'
        },
        {
          text: 'YES',
          handler: data => {
            this.storeTodrive()
          }
        }
      ]
    });
    alert.present();
  }
  initDriveEvents(events) {

    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "main") {
          if (data.event === 'showListView') {
            if (data['data']) {
              this.loadGridData();
            } else {
              this.showListView = false;
            }
          } else if (data.event === "showProgressStatus") {
            let status = data['status'];
            this.showProgressStatus = status;
          }
        }
        if (data.src === "drive-main") {
          if (data.event === 'showComponentHolder') {
            let flag = data['status'];
            if ((!this.sharedData) || (this.sharedData && this.sharedData.ShareType == "Folder")) {
              this.driveService.objCurrentFolder.files = [];
              this.showMainContainer = !flag;
              this.showComponentHolder = flag;
              if (this.sharedData.sharedInfo['mailSendType'] != undefined) {
                this.templateID = this.sharedData.sharedInfo['sharedFolder'].template[0].id;
                this.templateProperty = this.sharedData.sharedInfo['sharedFolder'].template[0];
                this.driveService.CurrentFilesData = this.sharedData.sharedInfo.rowData;
                this.loadGridData();
              } else {
                if (this.showComponentHolder == true) {
                  this.driveService.broadcastInfo({ src: 'main', event: 'headerShow', data: false });
                } else if (this.showComponentHolder == false) {
                  this.showAllFiles(this.driveService.objCurrentFolder);
                  this.driveService.broadcastInfo({ src: 'main', event: 'headerShow', data: true });
                }
              }
            } else if (this.sharedData && this.sharedData.ShareType == "File") {
              this.showMainContainer = !flag;
              this.showComponentHolder = flag;

              if (this.showComponentHolder == true) {
                this.driveService.broadcastInfo({ src: 'main', event: 'headerShow', data: FixedSizeVirtualScrollStrategy });
              } else if (this.showComponentHolder == false) {
                this.templateID = this.driveService.objCurrentFolder['template'][0]['id']
                this.driveService.CurrentFilesData = [];
                this.showAllFiles(this.driveService.objCurrentFolder);
                this.driveService.broadcastInfo({ src: 'main', event: 'headerShow', data: true });
              }
            } else if (data.event === 'showTemplateStatus') {
              let status = data['status']
              this.showTemplateStatus = status;
              this.templateSelection = 'New';
            } else if (data.event === "updateFolderProperties") {
              let status = data['status'];
              this.showMultitemp = status;
              let selectedTemplates = data['selectedTemplates']
              this.driveService.assignTemplateToFolder(selectedTemplates, this.objCurrentFolder, () => {
              })
            }
          }
        }

      });

  }

  get_Width() {
    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "header") {
          if (data.event === 'Hidepage') {
            let status = data['data'];
            if (status == true) {
              if (document.getElementById("headerw").style.width == '90%') {
                this.head_width = true;
              }
            } else {
              if (document.getElementById("headerw").style.width == '100%') {
                this.head_width = false;
              }
            }
          }
        }
      });
  }

  showFolderContent(clickedFolder, index) {
    this.objCurrentParentFolder = this.driveService.getCurrentParentFolder(index);
    if (clickedFolder.folder_type === 'smart_folder') {
      let template = clickedFolder['template'];
      template[template.length - 1]
      let filterParams = template[template["length"] - 1].filterParams;
      this.showAllFiles(clickedFolder);
      this.driveService.showContentSmartFolder(0, filterParams);
      this.showListView = false;
      this.driveService.gotoFolder(clickedFolder);
    } else {
      this.showListView = false;
      this.driveService.gotoFolder(clickedFolder);
      this.objFilterParams = this.driveService.getFileNameParam();
      this.loadGridData();
    }
  }

  showAllFiles(clickedFolder) {
    if (clickedFolder.template.length > 0) {
      this.selectedFolder = clickedFolder.template[0].templateName;
    }
    if (clickedFolder.template.length <= 0) {
      if (clickedFolder.folder_id !== 0) {
        this.driveService.broadcastInfo({ src: 'drive-main', event: 'showTemplateStatus', status: true });
      } else {
        this.driveService.broadcastInfo({ src: 'drive-main', event: 'showTemplateStatus', status: false });
      }
    } else {
      this.showListView = false;
      if (clickedFolder.template.length) {
        this.driveService.pullSyncData(0, null, clickedFolder, this.storeWrap.typeOfApi.summary, this.storeWrap.typeOfData.typeFile, this.getFileData)
      }
    }
  }

  getFileData = ((data) => {
    this.driveService.CurrentFilesData = data[0];
    if (data.length > 0) {
      this.showListView = true;
    }
  })

  loadGridData() {
    this.showListView = false;
    let __self = this;
    if (__self.sharedData.sharedInfo['mailSendType'] != undefined) {
      if (Object.keys(__self.templateProperty.colprops).length) {
        __self.showListView = true;
      }
    } else {
      if (__self.driveService.objCurrentFolder.template.length) {
        __self.templateID = __self.driveService.objCurrentFolder.template[0].id;
        __self.templateProperty = __self.driveService.storeWrap.storeTemplates[__self.templateID];
        if (Object.keys(__self.templateProperty.colprops).length) {
          __self.showListView = true;
        }
      }
    }
  }

  /* * * * * *
  * Context Menu 
  * * * * * */
  openFolderMenu(e, data, index) {
    this.objCurrentParentFolder = this.driveService.getCurrentParentFolder(index);
    this.objCurrentFolder = data;
    this.oldFolderName = data['name'];
    this.objCurrentFolderProperties = data;
    return false;
  }

  editFolderPopup(e) {
    this.showFolderMenu = false;
    let alert = this.alertCtrl.create({
      title: 'Rename',
      inputs: [
        {
          name: 'Name',
          value: this.oldFolderName
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Ok',
          handler: data => {
            this.driveService.renameSharedFolder(this.objCurrentFolder, data.Name);
          }
        }
      ]
    });
    alert.present();
  }

  sharePopup(event) {
    this.driveService.objCurrentFolder['files'] = [];
    let data = Object.assign({}, this.configApiService.driveApi.pushLinkShareUser.params, {
      "ShareID": '',
      "ShareType": 'Folder',
      "SharedInfo": { 'sharedFolder': this.objCurrentFolderProperties, 'recipientMailId': '', 'accessType': 'private' }

    })
    var modalPage = this.modal.create(DriveSharePage, { 'shareDataSet': data, "ShareType": 'File', 'ShareID': '', 'currentFolderName': this.objCurrentFolderProperties.name }, { cssClass: "data_Share" });
    modalPage.present();
    modalPage.onDidDismiss(data => {
    });
  }



  deleteFolderPopup(e) {
    this.showFolderMenu = false;
    let alert = this.alertCtrl.create({
      title: 'Are you sure, want to delete the folder ?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Ok',
          handler: data => {
            this.driveService.deleteSharedFolder(this.objCurrentFolder);
          }
        }
      ]
    });
    alert.present();
  }

  copyFolder(e) {
    this.objSelectedFolder = this.objCurrentFolderProperties;
    this.showPaste = true;
    this.showFolderMenu = false;
    const toast = this.toastController.create({
      message: 'Folder copy feature on processing',
      duration: this.configApiService.toastDuration
    });
    this.showFolderMenu = false;
    toast.present();
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === 'escape' || 'Esc') {
      if (this.showFolderMenu == true) {
        this.showFolderMenu = false;
      }
    }
  }

  moveFolder(event) {
    this.driveService.objCurrentFolder.folders = this.driveService.objCurrentFolder.folders.filter(item => item.folder_id != this.objCurrentFolderProperties.folder_id);
    this.objSelectedFolder = this.objCurrentFolderProperties;
    this.showPaste = true;
    this.showFolderMenu = false;
    const toast = this.toastController.create({
      message: 'Folder Moving feature on processing',
      duration: this.configApiService.toastDuration
    });
    this.showFolderMenu = false;
    toast.present();
    this.folderStatusMove = true;
  }

  pasteFolder(e) {
    this.driveService.objCurrentFolder;
    if (this.folderStatusMove == false) {
      this.driveService.moveFolder(this.objSelectedFolder, this.driveService.objCurrentFolder, false);
    } else if (this.folderStatusMove == true) {
      this.driveService.moveFolder(this.objSelectedFolder, this.driveService.objCurrentFolder, true);
    }
    this.folderStatusMove = false;
    this.showPaste = false;
    this.objCurrentFolderProperties = {};
  }
  objSelectedFolder(objSelectedFolder: any, objCurrentFolder: any, arg2: boolean) {
    throw new Error("Method not implemented.");
  }
  openProps(e) {
    var modalPage = this.modal.create(TemplateListsPage, { 'selectedTemplate': this.objCurrentFolderProperties, "templateType": 'Multiple' }, { cssClass: "Multi_template", showBackdrop: false });
    modalPage.present();
  }
  addFolder() {
    console.log()
    let ProgressCancelClicked = false;
    let alert = this.alertCtrl.create({
      title: 'New Folder',
      inputs: [
        {
          name: 'FolderName',
          placeholder: 'Folder Name'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: data => {
            console.log('Cancel clicked');
            ProgressCancelClicked = true;
          }
        },
        {
          text: 'Create',
          handler: data => {
            if (data["FolderName"].trim() == "") {
              const toast = this.toastController.create({
                message: 'Folder Name Cannot be Empty!',
                duration: this.configApiService.toastDuration,
              });
              toast.present();
              this.addFolder();
            } else {
              let foldername: any = this.driveService.objCurrentFolder["folders"].find(item => item.name == data.FolderName);
              if (foldername) {
                const toast = this.toastController.create({
                  message: 'Folder Name already exists. Please, create new foldername',
                  duration: this.configApiService.toastDuration
                });
                toast.present();
                this.addFolder();
              } else {
                ProgressCancelClicked = false;
                this.driveService.createFolder(data.FolderName);
                this.driveService.broadcastInfo({ src: 'drive-main', event: 'showTemplateStatus', status: true });
              }
            }
          }
        }
      ]
    });
    alert.present();
    this.driveService.broadcastInfo({ src: 'drive-main', event: 'showProgressStatus', status: true });
    let events = this.events;
    alert.onDidDismiss(function () {
      if (ProgressCancelClicked == true) {
        this.driveService.broadcastInfo({ src: 'drive-main', event: 'showProgressStatus', status: false });
      }
    });
  }

  openRuleEngine(e) {
    const componentFactory = this.resolver.resolveComponentFactory(RuleEngineSetupComponent);
    this.componentRef = this.viewContainerRef.createComponent(componentFactory);
    this.componentRef.instance.params = this.objCurrentFolderProperties;
    this.componentRef.instance.clear_Component.subscribe(() => { console.log("te"); this.clearComponent(); });
    this.showMainContainer = false;
  }

  clearComponent() {
    console.log("this.viewContainerRef", this.viewContainerRef);
    this.viewContainerRef.clear();
    this.showMainContainer = true;
  }

  storeTodrive() {
    let shareFolder = {};
    shareFolder = this.sharedData.sharedInfo.sharedFolder;
    let pushParams = { "userid": this.configureService.getLoginUserID(), "appCode": this.configApiService.currentDriveApp['app_code'], "folder": shareFolder, "action": "sharePaste", "shareID": this.sharedData.sharedInfo.ShareID }
    let objData = Object.assign({}, this.configApiService.driveApi.pushFolder.params, this.storeWrap.licenceClientDB, pushParams)
    this.configApiService.customRequest(this.configApiService.pushFolder, objData, (respData) => {
    })
  }

  ngOnDestroy() {
  }

}



// WEBPACK FOOTER //
// ./src/pages/share/share.ts